import { Flex, Text } from "@chakra-ui/react";
import * as React from "react";

import { useChoiceByDate } from "@/hooks/useChoiceByDate";

import { fireLocations } from "../constants";

type FireLocationProps = {
  auditDate: Date | undefined;
};

export const FireLocation = React.memo(({ auditDate }: FireLocationProps) => {
  const locationChoice = useChoiceByDate(auditDate, fireLocations.length);

  return (
    <Flex>
      <Text as="b">Fire Location:</Text>
      <Text marginLeft="5px">{fireLocations[locationChoice]}</Text>
    </Flex>
  );
});
